export const taiwanTrend = {
  up: {
    primary: '#d32f2f',
    secondary: '#f44336',
    light: '#ffebee',
    border: '#f28b82',
  },
  down: {
    primary: '#2e7d32',
    secondary: '#388e3c',
    light: '#e8f5e8',
    border: '#81c784',
  },
  neutral: {
    primary: '#616161',
    secondary: '#9e9e9e',
    light: '#f5f5f5',
    border: '#bdbdbd',
  },
} as const;

export type TrendDirection = 'up' | 'down' | 'neutral';

export interface TrendColorSet {
  primary: string;
  secondary: string;
  light: string;
  border: string;
}

export const getTrendColorSet = (change: number | null | undefined): TrendColorSet => {
  if (typeof change === 'number') {
    if (change > 0) {
      return taiwanTrend.up;
    }
    if (change < 0) {
      return taiwanTrend.down;
    }
  }
  return taiwanTrend.neutral;
};

export const getTrendDirection = (change: number | null | undefined): TrendDirection => {
  if (typeof change === 'number') {
    if (change > 0) return 'up';
    if (change < 0) return 'down';
  }
  return 'neutral';
};

export const getTrendTextColor = (change: number | null | undefined): string =>
  getTrendColorSet(change).primary;

export const getTrendChipProps = (change: number | null | undefined) => {
  const direction = getTrendDirection(change);
  switch (direction) {
    case 'up':
      return {
        color: undefined,
        sx: {
          color: '#fff',
          backgroundColor: taiwanTrend.up.primary,
          borderColor: taiwanTrend.up.border,
        },
      } as const;
    case 'down':
      return {
        color: undefined,
        sx: {
          color: '#fff',
          backgroundColor: taiwanTrend.down.primary,
          borderColor: taiwanTrend.down.border,
        },
      } as const;
    default:
      return {
        color: 'default' as const,
        sx: {
          color: taiwanTrend.neutral.primary,
          borderColor: taiwanTrend.neutral.border,
        },
        variant: 'outlined' as const,
      };
  }
};
